export default __webpack_public_path__ + "static/media/img_baseCottonEars_flowers_p.8b084e3e.jpg";